import { useEffect, useRef } from "react";
import TopNav from "../../component/navigationBar/TopNav";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import User from "../../component/user/User";
import { useNavigate } from "react-router-dom";
import { restoreCmsLogin } from "../../redux/auth/thunk";
import { changePageThunk } from "../../redux/common/navBar/thunkl";
import Inspection from "../inspection/Inspection";
import CompanyTitleBar from "../../component/companyTitleBar/CompanyTitleBar";
import styles from "./cmsDashBoard.module.css";
import { Grid } from "@mui/material";
import RouteName from "../Route/Route";
import Collection from "../collection/Collection";
import CleaningRoute from "../CleaningRoute/CleaningRouteDesign";
import Cleaning from "../Cleaning/Cleaning";
import BinManage from "../binManagement/BinManage";
import Contract from "../Contract/Contract";
import PeopleCounter from "../peopleCounter/PeopleCounter";

function CMSDashoard() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const navigate = useNavigate();
    const { page } = useSelector((state: IRootState) => state.initNavBarState);
    const dataFetchedRef = useRef(false);

    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        dispatch(restoreCmsLogin(navigate));

        return () => {
            controller.abort();
        };
    }, [dispatch, navigate]);

    function handlelogout() {
        localStorage.removeItem("loginToken");
        dispatch(changePageThunk(2,0));
        window.location.reload();
        return null;
    }

    return (
        <>
            <Grid className={styles.DashbardOuterContainer}>
                <CompanyTitleBar />
                <TopNav />
            </Grid>
            {/* page is navBar_id in DB */}
            <Grid className={styles.MainContentContainer}>
              
                {page === 2 ? <User /> : <></>}
                {page === 3 && handlelogout()}
                {page === 4 ? <Inspection /> : <></>}
                {page === 5 ? <Cleaning /> : <></>}       
                {page === 6 ? <RouteName /> : <></>}
                {page === 8 ? <BinManage /> : <></>}     
                {page === 9 ? <Collection/>:<></>}      
                {page === 12?<CleaningRoute/>:<></>}    
                {page === 15? <Contract/>:<></>}
                     {page === 17? <PeopleCounter/>:<></>}
            </Grid>

        </>
    );
}

export default CMSDashoard;
